import { createActionHelpers } from 'vuex-loading';
import Vue from 'vue';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_REPORT_OPERATION = 'UPDATE_REPORT_OPERATION';
export const UPDATE_PLEDGE_OPERATION = 'UPDATE_PLEDGE_OPERATION';
export const initModuleAction = 'initModuleAction';
export const saveOperationAction = 'saveOperationAction';

export default {
  namespaced: true,
  state: {
    loading: false,
    report: null,
    pledge: null,
  },
  mutations: {
    [UPDATE_LOADING](state, payload) {
      Vue.set(state, 'loading', payload);
    },
    [UPDATE_REPORT_OPERATION](state, payload) {
      if (!payload.id) {
        payload.id = 'dummy';
      }
      Vue.set(state, 'report', payload);
    },
    [UPDATE_PLEDGE_OPERATION](state, payload) {
      Vue.set(state, 'pledge', payload);
    },
  },
  actions: {
    async initModuleAction({ dispatch, commit, rootGetters }, id) {
      startLoading(dispatch, 'analisis');
      const configReport = {};
      const configPledge = {};
      configReport.opReport = {
        operator: '=',
        value: id,
        path: 'uuid',
        parent: 'node--operation',
        parentProperty: 'report',
      };
      configPledge.opPledge = {
        operator: '=',
        value: id,
        path: 'uuid',
        parent: 'node--operation',
        parentProperty: 'pledge',
      };
      await dispatch('propuestano/initModuleAction', id, { root: true });
      await dispatch('collaborator/initModuleAction', null, { root: true });
      const pledgeResponse = await dispatch('pledge_model/fetchAction', configReport, { root: true });
      const reportResponse = await dispatch('report_model/fetchAction', configReport, { root: true });
      const { entities } = reportResponse;
      if (entities && entities.length) {
        commit(UPDATE_REPORT_OPERATION, entities[0]);
      } else {
        commit(UPDATE_REPORT_OPERATION, {});
      }
      if (pledgeResponse && pledgeResponse.entities) {
        const pledge = pledgeResponse.entities;
        if (Array.isArray(pledge)) {
          commit(UPDATE_PLEDGE_OPERATION, entities[0]);
        }
      }
      endLoading(dispatch, 'analisis');
    },
    updateLoading({ dispatch, commit, rootGetters }, flag) {
      return commit(UPDATE_LOADING, flag);
    },
  },
  getters: {
    loading: state => state.loading,
    report: state => state.report,
    pledge: state => state.pledge,
  },
};



// WEBPACK FOOTER //
// ./src/features/analisis/store.js